export default [
  {
    path: "/framework-domains-test-audit/:type",
    name: "FrameworkDomainsTestAudit",
    component: () =>
      import(
        "@/views/Page/FrameworkDomainsTestAudit/FrameworkDomainsTestAudit.vue"
      ),
    meta: {
      title: "#Default# | FrameworkDomainsTestAudit",
    },
  },
  {
    path: "/framework-domains-test-audit/:id/result",
    name: "FrameworkDomainsTestAudit-Result",
    component: () =>
      import(
        "@/views/Page/FrameworkDomainsTestAudit/componentResultAudit/mainStep.vue"
      ),
    meta: {
      title: "FrameworkControlTestAuditResult",
    },
  },
];
